/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */
app.controller('getPasswordResetUrlCtrl', ['$rootScope', '$scope', '$http', 'NetworkService', 'MainService', 'AtlasNotification', 'LoginService', 'NetworkService', function($rootScope, $scope, $http, networkService, MainService, AtlasNotification, LoginService, NetworkService) {

    $scope.gui = {};
    $scope.gui.email = { disabled: false };
    $scope.gui.view = {};
    $scope.gui.view.visible = false;

    
    $rootScope.$on("passwordReset_view", function(e, data){
        if(data.cmd == "open"){
            $scope.gui.view.visible = true;
        }
    })
    
    $scope.showLoginView = function(){
        $scope.gui.view.visible = false;
        $rootScope.$emit("login_view", {cmd: "open"});
    }
    
    $scope.resetPassword = function() {
        var data = {email: $scope.email}
       NetworkService.callOperation("getpasswordreseturl", data, function(response){
           AtlasNotification.info("Der Link zum zurücksetzen deines Passwortes wurde dir zugestellt.")
       })
    }

}])
